export const CHECKOUT_STEPS = [
  { id: 1, label: 'Address' },
  { id: 2, label: 'Review' },
  { id: 3, label: 'Payment' },
];

export const DELIVERY_FEE = 40;
export const FREE_DELIVERY_THRESHOLD = 500;

export const INITIAL_FORM = {
  fullName: '',
  phone: '',
  email: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  pincode: '',
};
